import { useCallback } from 'react';

import { sessionId } from '@atlas/core';

import { OAUTH_FLOW_TYPES, POSTHOG_EVENTS, POSTHOG_FORM } from 'common/constants';

import usePostHog from './usePostHog';

export const resolveForm = flowType =>
  flowType === OAUTH_FLOW_TYPES.SIGNIN ? POSTHOG_FORM.SIGN_IN : POSTHOG_FORM.SIGN_UP;

const useGoogleRegistrationPostHog = () => {
  const postHog = usePostHog();

  const handleGoogleClick = useCallback(
    ({ flowType, pageRefer = null, totalRegistrationSteps = 1 }) => {
      postHog.send(POSTHOG_EVENTS.GOOGLE_REGISTRATION, {
        form: resolveForm(flowType),
        page_refer: pageRefer,
        session_id: sessionId,
        shown_timestamp: Date.now(),
        total_registration_steps: totalRegistrationSteps ?? 1,
      });
    },
    [postHog],
  );

  return { handleGoogleClick };
};

export default useGoogleRegistrationPostHog;
